<div class="container" [ngClass]="containerClass()">
    <horizon-page-header [title]="title()" [actionLabel]="actionLabel()"
                         (actionClick)="onActionClick()"></horizon-page-header>
</div>
